import React from 'react'
import { useFlag, RouteParams } from '@sketch/modules-common'
import { Redirect, useParams } from 'react-router'
import { LocationDescriptorObject } from 'history'
import { useVersioning } from 'modules/versioning'
import { PrototypeViewNext } from './PrototypeViewNext/PrototypeViewNext'

export function PrototypeViewNextFFGate() {
  const isWebGLPrototypePlayerOn = useFlag('webgl-prototype-player')
  const { currentArtboardUUID, shareID } = useParams<
    RouteParams<'PROTOTYPE_VIEW_NEXT'>
  >()
  const { getPathname } = useVersioning()

  if (isWebGLPrototypePlayerOn) {
    return <PrototypeViewNext />
  } else {
    const to: LocationDescriptorObject = {
      pathname: getPathname({
        routeKey: 'PROTOTYPE_VIEW',
        routeParams: {
          shareID,
          artboardUUID: currentArtboardUUID,
        },
      }),
    }
    return <Redirect to={to} push={false} />
  }
}
